import { render, staticRenderFns } from "./ChangeDomainLink.vue?vue&type=template&id=a968cee2"
import script from "./ChangeDomainLink.vue?vue&type=script&lang=js"
export * from "./ChangeDomainLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a968cee2')) {
      api.createRecord('a968cee2', component.options)
    } else {
      api.reload('a968cee2', component.options)
    }
    module.hot.accept("./ChangeDomainLink.vue?vue&type=template&id=a968cee2", function () {
      api.rerender('a968cee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeDomainLink/ChangeDomainLink.vue"
export default component.exports